import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../../app.config';

@Injectable()
export class PlatformsService {
  constructor (private http: HttpClient , private api: AppConfig) {
  }

  addPlatform (data) {
    return this.http.post(this.api.baseUrl + '/platform/addPlatform' , data , this.api.jsonTokenHeaders);
  }

  getPlatforms () {
    return this.http.get(this.api.baseUrl + '/platform/getPlatforms' , this.api.jsonTokenHeaders);
  }

  getAllPlatforms () {
    return this.http.get(this.api.baseUrl + '/platform/getAllPlatforms' , this.api.jsonTokenHeaders);
  }

  getByOrganizationId (id, onlyEnable = false) {
    return this.http.get(this.api.baseUrl + '/matrixPlatform/getByOrganizationId?id=' + id + '&onlyEnable=' + onlyEnable , this.api.jsonTokenHeaders);
  }

  getPlatformById (id) {
    return this.http.get(this.api.baseUrl + '/platform/getPlatformById?id=' + id , this.api.jsonTokenHeaders);
  }

  getMatrixPlatform(page = 1, perPage = 50, search = '') {
    return this.http.get(this.api.baseUrl + '/matrixPlatform/getMatrixPlatforms?page=' + page +
      '&perPage=' + perPage + '&search=' + search, this.api.jsonTokenHeaders);
  }

  addMatrixPlatform (data) {
    return this.http.post(this.api.baseUrl + '/matrixPlatform/addMatrixPlatform' , data , this.api.jsonTokenHeaders);
  }
}
